import { useEffect, useState } from 'react';
import { Layout, Menu, message, Select, Typography } from 'antd';
import { generateMenuIcon } from '../../utils/functions';
import { Link } from 'react-router';
import { useDocumentCategoryContext } from '../../context/documentCategoryContext';
import CommonServices from '../../services/commonServices';
import { notifyMessages } from '../../utils/constants';
import { useCurrentUserContext } from '../../context/currentUserContext';
import { useLoader } from '../../context/loaderContext';
const { Text } = Typography;
const { Sider } = Layout;

const AppMenuSider = () => {

  const [collapsed, setCollapsed] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const { documentCategories } = useDocumentCategoryContext();
  const { currentUser } = useCurrentUserContext();
  const { setLoading, setLoadingText } = useLoader();

  useEffect(() => {
    getMenuItems();
  }, []);

  const categoryList = documentCategories && documentCategories.map(item => ({
    value: item.id,
    label: item.description
  }));

  const getMenuItems = async () => {
    try {
      const respData = await CommonServices.getMenus(currentUser.id);
      if (respData.success) {
        const res = respData.responseObject.value.menuList;
        generateUserMenu(res);
      }
    } catch (error) {
      console.error('Failed to fetch profile:', error.message);
    }
  };

  const generateUserMenu = async (menuData) => {
    let userMenu = [];
    menuData.map((item) => {
      userMenu.push({
        label: <Link to={{ pathname: item.menuLink }}>{item.displayName}</Link>,
        key: item.id,
        icon: generateMenuIcon(item.menuLink),
        link: item.menuLink
      });
      setMenuList(userMenu);
    });
  }

  const handleChangeCategory = async (selectedCategory) => {
    const payload = {
      userID: currentUser.id,
      categoryID: selectedCategory
    }
    setLoading(true);
    setLoadingText("Cambiando tipologia...");
    try {
      const respData = await CommonServices.updateDocCategory(payload);
      if (respData.success) {
        message.success("Cambiando tipologia...");
        window.location.replace("/");
      }
      else {
        message.error(notifyMessages.errorAccured);
      }

    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
    finally {
      setLoading(false);
      setLoadingText(null);
    }
  };

  return (
    <Sider className='appMenuSider' width={200} collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
    
      <Text style={{ color: "#ffffff", display: "flex", justifyContent: "center", marginTop: 5 }}>Tipo documento</Text>
      <Select
        defaultValue={currentUser.lastSelectedCategory}
        className='categorySelect'
        onChange={handleChangeCategory}
        options={categoryList}
      />
      <Menu
        mode="inline"
        style={{ height: '100%', borderTop: "1px solid #86a5b1" }}
        items={menuList}
      />
    </Sider>
  );
}
export default AppMenuSider;